module.exports = __webpack_public_path__ + "img/calendar.8831ce15.svg";